module.exports = __webpack_public_path__ + "static/media/5-STAR_Golf.9c50a975.png";